import { S3TimeKeyLevel } from '@iotv/datamodel-core';
import { createContext } from 'react';
import { AppLocalStorage } from '../../data/LocalStorage/AppLocalStorage';
import { NavSections } from '../navigation/NavSections';
const { REACT_APP_PROJECT_CODE: projectCode, REACT_APP_DEPLOYMENT_STAGE: stage, REACT_APP_DEBUG } = process.env;
const debug = REACT_APP_DEBUG && false;
const bucketIdentifier = `${projectCode}-${stage}-logs-main`;
export var Logs;
(function (Logs) {
    Logs[Logs["wideawake"] = 0] = "wideawake";
    Logs[Logs["networkData"] = 1] = "networkData";
    Logs[Logs["networkDataContainer"] = 2] = "networkDataContainer";
    Logs[Logs["ui"] = 3] = "ui";
    Logs[Logs["entityState"] = 4] = "entityState";
    Logs[Logs["entityStateContainer"] = 5] = "entityStateContainer";
    Logs[Logs["thingAlerts"] = 6] = "thingAlerts";
    Logs[Logs["datalifecycle"] = 7] = "datalifecycle";
    Logs[Logs["coverage"] = 8] = "coverage";
    Logs[Logs["fanOut"] = 9] = "fanOut";
    Logs[Logs["fanOutContainer"] = 10] = "fanOutContainer";
    Logs[Logs["importExport"] = 11] = "importExport";
    Logs[Logs["scheduledReports"] = 12] = "scheduledReports";
    Logs[Logs["smartQueueMgmt"] = 13] = "smartQueueMgmt";
    Logs[Logs["hotCold"] = 14] = "hotCold";
    Logs[Logs["systemOperation"] = 15] = "systemOperation";
    Logs[Logs["dashboardQuery"] = 16] = "dashboardQuery";
    Logs[Logs["deviceControlState"] = 17] = "deviceControlState";
    Logs[Logs["entityHistory"] = 18] = "entityHistory";
    Logs[Logs["entityBucketedReadings"] = 19] = "entityBucketedReadings";
})(Logs || (Logs = {}));
export const logReadableNames = {
    wideawake: 'Wideawake',
    networkData: 'Network Data',
    networkDataContainer: 'Network Data ECS Task',
    ui: 'UI',
    entityState: 'Entity State',
    entityStateContainer: 'Entity State ECS Task',
    thingAlerts: 'Thing Alerts',
    datalifecycle: 'Data Life Cycle',
    coverage: 'Coverage',
    fanOut: 'Fan Out',
    fanOutContainer: 'Fan Out ECS Task',
    importExport: 'Import / Export',
    scheduledReports: 'Scheduled Reports',
    smartQueueMgmt: 'Smart Queue Management',
    hotCold: 'Hot Cold Lambda',
    systemOperation: 'System Operation',
    dashboardQuery: 'Dashboard Query',
    deviceControlState: 'Device Control State',
    entityHistory: 'Entity History',
    entityBucketedReadings: 'Entity Bucketed Readings',
};
export const prefixes = {
    wideawake: `${projectCode}-${stage}-wideawake`,
    networkData: `${projectCode}-${stage}-NetworkData-Stack-Processor`,
    networkDataContainer: `${projectCode}-${stage}-networkData`,
    ui: `${projectCode}-${stage}-ui`,
    entityState: `${projectCode}-${stage}-EntityState`,
    entityStateContainer: `${projectCode}-${stage}-entityState`, // near miss only by virtue of caps
    thingAlerts: `${projectCode}-${stage}-ThingAlerts-Stack_processEvent`,
    datalifecycle: `${projectCode}-${stage}-DataLifecycle-Stack-Processor`,
    coverage: `${projectCode}-${stage}-NetworkAPI-Stack-NetworkCoverage`,
    fanOut: `${projectCode}-${stage}-FanOut-Stack-LambdaFanOut`,
    fanOutContainer: `${projectCode}-${stage}-fan-out`,
    hotCold: `${projectCode}-${stage}-hotCold`,
    systemOperation: `${projectCode}-${stage}-SystemSelfCheck-Stack-Processor`,
    importExport: `${projectCode}-${stage}-ConsumerDataIO_processEvent`,
    scheduledReports: `${projectCode}-${stage}-ScheduledReports_processEvent`,
    dashboardQuery: `${projectCode}-${stage}-consumer-data-Stack-dashboard`,
    entityHistory: `${projectCode}-${stage}-consumer-data-Stack-getObjectHistory`,
    entityBucketedReadings: `${projectCode}-${stage}-consumer-data-Stack-entitybucketedReadings`,
    deviceControlState: `${projectCode}-${stage}-device-control-deviceState`,
    /** TODO Bad projectCode stage order!! */
    smartQueueMgmt: `${stage}-${projectCode}-device-control-arbitration`,
};
export const defaultLogState = {
    contentRecords: [],
    fetchingRecords: false,
    selectedService: AppLocalStorage.get(NavSections.SYSTEM_LOGS, 'selectedService') ?? prefixes.entityState,
    fetchingEntry: false,
    selectedEntry: undefined,
    containedItems: [],
    groupArraysAfterLength: 1,
    defaultInspectDepth: 3,
    selectionModel: { type: 'include', ids: new Set() },
};
// logs are indexed like i3012-dev-NetworkData-Stack-Processor/2023/01/23/03:30:46:486
export const getS3Key = (servicePrefix, s3TimeKey) => {
    let k = undefined;
    if (servicePrefix) {
        try {
            const [y, m, d, h, min, s, ms] = s3TimeKey;
            debug && console.log({ y, m, d, h, min, s, ms });
            k = `${servicePrefix}/${y}/${m}/${d}/${h}:${min}`;
        }
        catch (e) {
            console.log('err getting s3 key', e.message);
        }
    }
    return k;
};
export const s3TimeLevel = S3TimeKeyLevel.MINUTE;
export const LogViewerContext = createContext({
    state: defaultLogState,
    dispatch: () => {
        throw new Error('Uninitialized use fo LogViewerContext');
    },
});
